module.exports = __webpack_public_path__ + "static/media/intelli-full-width.c71e2f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/intelli-full-width.png
// module id = 794
// module chunks = 0